import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import Login from './Components/Login/login';
import Dashboard from './Components/Dashboard/dashboard';
import Taaruf from './Components/Taaruf/taaruf';
import Mujjalah from './Components/Tableeghat/mujjalah';
import NoorDiary from './Components/Tableeghat/noorDiary';
import Tazakuraat from './Components/Tazakuraat/tazakuraat';
import AddArticle from './Components/Tazakuraat/AddArticle';
import EditArticle from './Components/Tazakuraat/EditArticle';
import Users from './Components/userManagement/Users';
import CreateUser from './Components/userManagement/CreateUser';
import LayoutPage from './Components/layout/LayoutPage';
import ProtectedRoute from './proctedRoutes';
import { AuthProvider, useAuth } from './Components/context/AuthContext';
import PermissionDenied from './Components/PermissionDenied';
import Banners from './Components/Munasibaat/banners';
import TazakuraatReview from './Components/Tazakuraat/TazakuraatReview';
import CreateNoorDiary from './Components/Tableeghat/createNoorDiary';
import EditNoorDiary from './Components/Tableeghat/editNoorDiary';
import AddMujjalah from './Components/Tableeghat/AddMujjalah';
import EditMujjalah from './Components/Tableeghat/EditMujjalah';
import ReviewArticle from './Components/Tazakuraat/reviewArticle';
import EditPreviewArticle from './Components/Tazakuraat/EditPreviewArticle';
import Books from './Components/Tableeghat/books/Books';
import CreateBook from './Components/Tableeghat/books/CreateBook';
import EditBook from './Components/Tableeghat/books/EditBook';
import FirstPage from './Components/firstPage/FirstPage';
import AddAyat from './Components/firstPage/AddAyat';
import EditAyat from './Components/firstPage/EditAyat';
import StudentsDatabase from './Components/StudentsDatabase/StudentsDatabase';
import ThemeManagement from './Components/ThemeManagement/ThemeManagement';
import Munasibaat from './Components/Munasibaat/munasibaat';
import CreateMunasibaat from './Components/Munasibaat/CreateMunasibaat';
import EditMunasibaat from './Components/Munasibaat/EditMunasibaat';
import ClassForms from './Components/ClassForms/ClassForms';
import LinearProgress from '@mui/material/LinearProgress';
import { useState } from 'react';
import AboutSections from './Components/AboutSections/AboutSections';
import FAQManagement from './Components/FAQ/FAQManagement';
import EditUser from './Components/userManagement/EditUser';
import Exibition from './Components/Exibitions/Exibition';
import CreateExhibition from './Components/Exibitions/CreateExhibition';
import EditExhibition from './Components/Exibitions/EditExhibition';
import ExhibitionContent from './Components/Exibitions/ExhibitionContent';
import AddExhibitionContent from './Components/Exibitions/AddExhibitionContent';
import EditExhibitionContent from './Components/Exibitions/EditExhibitionContent';
import NamazTimings from './Components/NamazTimings/NamazTimings';
import PostApproval from './Components/PostApproval/PostApproval';
import MyPosts from './Components/PostApproval/MyPosts';
import AuditLogs from './Components/AuditLogs/AuditLogs';

function App() {
  const [pageLoading, setPageLoading] = useState(true);
  useEffect(() => {
    document.title = 'CMS | Mushtaqan e Noor';
    setPageLoading(false);
  }, []);

  return (
    <AuthProvider>
      {pageLoading && <LinearProgress />}
      <Router>
        <Routes>
          <Route path="/" element={<NavigateToCorrectPage />} />
          <Route path="/login" element={<LoginRoute />} />


          <Route element={<ProtectedRoute />}>          
            <Route element={<LayoutPage />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/permissionDenied" element={<PermissionDenied />} />
            </Route>
          </Route>
          <Route element={<ProtectedRoute allowedPermissions={["Munasibaat"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/munasibaat" element={<Munasibaat />} />
              <Route path="/banners" element={<Banners />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["Taaruf"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/taaruf" element={<Taaruf />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["Mujjalah"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/mujjalah" element={<Mujjalah />} />
              <Route path="/mujjalah/createMujjalah" element={<AddMujjalah />} />
              <Route path="/mujjalah/editMujjalah" element={<EditMujjalah />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["Noor-Diary"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/noor-diary" element={<NoorDiary />} />
              <Route path="/noor-diary/createNoorDiary" element={<CreateNoorDiary />} />
              <Route path="/noor-diary/editNoorDiary" element={<EditNoorDiary />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["Books"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/books" element={<Books />} />
              <Route path="/books/createBook" element={<CreateBook />} />
              <Route path="/books/editBook" element={<EditBook />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["Tazakraat"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/tazakuraat" element={<Tazakuraat />} />
              <Route path="/tazakuraat/addTazakraat" element={<AddArticle />} />
              <Route path="/tazakuraat/editTazakraat" element={<EditArticle />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["UserManagement"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/users" element={<Users />} />
              <Route path="/users/createUser" element={<CreateUser />} />
              <Route path="/users/editUser/:id" element={<EditUser />} />
              <Route path="/studentsDatabase" element={<StudentsDatabase />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["ThemeManagement"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/thememanagement" element={<ThemeManagement />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["Review-Tazakuraat"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/tazakraatreview" element={<TazakuraatReview />} />
              <Route path="/tazakraatreview/reviewArticle" element={<ReviewArticle />} />
              <Route path="/tazakraatreview/editArticle" element={<EditPreviewArticle />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["Home"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/home" element={<FirstPage/>} />
              <Route path="/home/addAyat" element={<AddAyat/>} />
              <Route path="/home/editAyat" element={<EditAyat/>} />
            </Route>
          </Route>


          <Route element={<ProtectedRoute allowedPermissions={["Munasibaat"]} />}>
          <Route element={<LayoutPage />}>
          <Route path="/munasibaat" element={<Munasibaat/>} />
          <Route path="/munasibaat/createMunasibaat" element={<CreateMunasibaat/>} />
          <Route path="/munasibaat/editMunasibaat" element={<EditMunasibaat/>} />         
          </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["ClassForms"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/class-forms" element={<ClassForms />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["AboutSections"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/aboutsections" element={<AboutSections />} />
            </Route>
          </Route>
          <Route element={<ProtectedRoute allowedPermissions={["FAQManagement"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/faqmanagement" element={<FAQManagement />} />
            </Route>
          </Route>
           <Route element={<ProtectedRoute allowedPermissions={["Exhibition"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/exhibition" element={<Exibition />} />
              <Route path="/exhibition/createExhibition" element={<CreateExhibition />} />
              <Route path="/exhibition/editExhibition" element={<EditExhibition />} />

            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["ExhibitionContent"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/exhibitionContent" element={<ExhibitionContent />} />
              <Route path="/exhibitionContent/addExhibitionContent" element={<AddExhibitionContent />} />
              <Route path="/exhibitionContent/editExhibitionContent" element={<EditExhibitionContent />} />

            </Route>
          </Route>

          <Route element={<ProtectedRoute allowedPermissions={["NamazTimings"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/namazTimings" element={<NamazTimings />} />
            </Route>
          </Route>
          <Route element={<ProtectedRoute allowedPermissions={["PostUpload"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/myposts" element={<MyPosts />} />
            </Route>
          </Route>
          <Route element={<ProtectedRoute allowedPermissions={["PostApproval"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/postapproval" element={<PostApproval />} />
            </Route>
          </Route>
          <Route element={<ProtectedRoute allowedPermissions={["AuditLogs"]} />}>
            <Route element={<LayoutPage />}>
              <Route path="/auditlogs" element={<AuditLogs />} />
              <Route path="/audit-logs" element={<AuditLogs />} />
            </Route>
          </Route>

        </Routes>
      </Router>
    </AuthProvider>
  );
}

function NavigateToCorrectPage() {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? <Navigate to="/dashboard" /> : <Navigate to="/login" />;
}

function LoginRoute() {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? <Navigate to="/dashboard" /> : <Login />;
}

export default App;
